import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'
import { ulLiCss, olLiCss } from '../../../../../util'

export const OuterWrapper = styled(Box)( props => `
  padding: 8px;
  display:flex;
  position: relative;

  & .editIcon {
    position: absolute;
    top: 12px;
    right: 12px;
    visibility: hidden;
  }
  &:hover .editIcon {
    visibility: visible;
  }
`)

const container = `
  padding: 16px;
  width: 100%;
  display:flex;
  border-radius: 4px;
  background: #FFF;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
  
  // overflow: auto; // adding scroll bar
`

export const Wrapper = styled(Box)( props => `
  ${container};
  justify-content: center;
  align-items: center;
`)

export const StatBoxWrapper = styled(Box)( props => `
  ${container};
  height: 100%;
  flex-wrap: wrap;
  align-items: self-start;


  & .percent-box {
    border: 1px solid ${props?.color || '#333'};
    border-radius: 8px;
    height: 90px;
    width: 120px;
    font-size: 56px;
    font-weight: 400;
    color: ${props?.color || '#333'};
    display: flex;
    align-items: center;
    justify-content: center;
    line-height:1;
    margin: 13px 10px 13px 0;
  }

  & .percent-box span {
    font-size: 22px;
    margin-left: 4px;
    height: 45px;
    width: fit-content;
    color: #000;
  }

  & .ratio-box {
    background-color: #f5f5f5;
    border-radius: 4px;
    padding: 4px 10px;
    font-weight: 600;
    font-size: 16px;
    margin-top: 60px;
    color: #000;
  }

  & .footer-text {
    font-size: 12px;
    font-weight: 400;
    width: 100%;
    color: #000;
  }

`)

export const D3DonutWrapper = styled(Box)( props => `
  ${container};
  height: 100%;
  flex-direction: column;
  & > div {
    margin-top:5px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }

  & .my_tooltip {display: none;}
`)

export const D3Donut = styled(Box)( props => `
  width: 120px;
  height: 120px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  position: relative;
  & svg {
    fill: ${props?.color || '#333'};
  }
  & svg text {
    fill: #fff;;
    font-size: 0 !important;
  }
`)

export const D3DonutLabel = styled(Box)( props => `
  width: 100%;
  height: 20px;
  display: block;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  color: #686867 !important;
  line-height: 15px;
`)

export const D3DonutValue = styled(Box)( props => `
  color: ${props?.color || '#333'} !important;
  font-size: 28px !important;
  font-weight: 600;
  position:absolute;
  line-height: 1;
  top: 37px;
  left: 0;
  width:100%;
  display: flex;
  justify-content: center;
`)
    
export const D3DonutPercentage = styled(Box)( props => `
  color: #333;
  font-size: 13px;
  line-height: 1;
  font-weight: 400;
`)

export const FreeTextWrapper = styled(Box)( props => `
  ${container};
  flex-direction: column;

  & .freeTextWrap {
    width: 100%;
    font-size: 12px; margin-top:8px;
  }
  & .freeTextWrap { ${ulLiCss}; ${olLiCss};}
`)

export const HiddenWrapper = styled(Box)( props => `
  ${container};
  background: transparent !important;
  box-shadow: none !important;
`)

export const D3HBarWrapper = styled(Box)( props => `
  ${container};
  flex-direction: column;

  & .hBarWrap {
    padding-top: 12px;
    gap:8px;
    width: 100%;
    min-height:16px;
    padding-bottom: 8px;
    display: inline-table;
  }
`)

export const D3HBar = styled(Box)( props => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;

  & .item-name {
    flex: 1;
    font-size: 12px;
    line-height: 12px;
    color: #000;
    font-weight: 400;
    width: calc(100% - 95px);
  }

  & .bar-container {
    background: #EFEFEF;
    border-radius: 4px;
    height: 4px;
    width: 60px;
    margin: 0 10px;
    position: relative;
    overflow: hidden;
  }

  & .bar-fill {
    background: ${props?.color || '#333'};
    height: 100%;
    border-radius: 4px;
  }

  & .item-value {
    font-size: 12px;
    font-weight: 600;
    color: ${props?.color || '#333'};
    width: 30px;
    text-align: right;
  }
`)

export const D3VBarWrapper = styled(Box)( props => `
  ${container};
  height: 100%;
  flex-wrap: wrap;
  justify-content: center;

  & .my_tooltip {display: none;}

  & .chart-container {
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    width: 100%;
    height: 140px;
  }

  & .bar-group {
    text-align: center;
    width: 100%;
    height: 120px;
    display: block;
    
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: anchor-center;
    flex-wrap: wrap;
  }

  & .bar {
    width: 25px;
    height: calc(100% - 30px);
    display: flex;
    align-items: end;
    justify-self: anchor-center;

    flex-wrap: wrap;
    justify-content: center;
  }

  & .bar-label {
    height: 20px;
    font-size: 12px;
    font-weight: 400;
    width: 100%;
    border-top: 1px solid #E7E7E6;
    background: #fff;
  }
`)

export const D3VBar = styled(Box)( props => `
  width: 100%;
  display: block;
  position: relative;

  &:before {
    content: '${props.value}';
    top: -20px;
    position: absolute;
    left: 0;
    font-size: 12px;
    width: 100%;
  }
`)

export const D3PieWrapper = styled(Box)( props => `
  ${container};
  height: 100%;
  flex-wrap: wrap;
  justify-content: space-between;

  & .my_tooltip {display: none;}
  & svg {margin-top:5px;}
`)

export const D3PieLegends = styled(Box)( props => `
  display:flex;
  flex-direction:column;
  width: 100px;
  height: calc(100% - 10px);
  align-items: start;
  justify-content: center;
`)

export const CardTitle = styled(Typography)( props => `
  width: 100%;
  // height: 20px;
  display: block;
  font-size: 14px;
  font-weight: 400;
  color: #000;
  line-height: 13px;
  
  // white-space: nowrap;
  // overflow: hidden;
  // text-overflow: ellipsis;
  padding-right: 14px;
`)

export const D3PieLegendLabel = styled(Box)( props => `
  display:flex;
  padding: 0 0 4px 15px; 
  font-size: 12px;
  color:#000;
  position:relative;
  line-height: 14px;
  width: calc(100% + 12px);
  display: inline-block;

  &:before {
    position: absolute;
    top: 2px;
    left: 3px;
    content:'';
    width:8px;
    height:8px;
    border-radius: 50%;
    display: block;
    background-color: ${props.color}
  }
`)
